<script>
  export let response
  export let index
  export let active_question

  function jump(i) {
    active_question = i
  }

  $: statusClass =
    active_question === index ? 'cbt-quiz-nav-btn--active' :
    response.checked ? 'cbt-quiz-nav-btn--marked' :
    response.choice === '' ? 'cbt-quiz-nav-btn--empty' :
    'cbt-quiz-nav-btn--answered'
</script>

<button
  type="button"
  class="cbt-quiz-nav-btn {statusClass}"
  on:click={() => jump(index)}
>
  {response.no}
</button>
